import { call, put } from 'redux-saga/effects';

import generateQuery from 'utils/generateQuery';

import {
  axiosAuthInstance,
  API_END_POINTS,
} from 'api';
import { MESSAGES } from 'appconstants';

import {
  ADMIN_ORDERS,
  LOADING,
  NOTIFICATION,
} from '../actionTypes';

const fetchAdminOrders = async (payload) => {
  const query = generateQuery(payload.currentPage);
  const sorting = payload.sortParams ? payload.sortParams : '&sortBy=createdAt&direction=DESC';
  if (payload.filterParams && !payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.GET_INTERNAL_ORDER}?${payload.filterParams}`);
  }
  if (payload.filterParams && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.GET_INTERNAL_ORDER}${query}${sorting}&${payload.filterParams}`);
  }
  if (!payload.filterParams && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.GET_INTERNAL_ORDER}${query}${sorting}`);
  }
  return axiosAuthInstance.get(`${API_END_POINTS.GET_INTERNAL_ORDER}${query}${sorting}`);
};

const updateAdminOrder = async ({ gid, params }) => axiosAuthInstance.patch(`${API_END_POINTS.GET_INTERNAL_ORDER}/${gid}`, params);

export function* getAdminOrders(action) {
  try {
    const { data: { entity } } = yield call(fetchAdminOrders, action.payload);
    yield put({ type: ADMIN_ORDERS.SUCCESS, payload: entity });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
    yield put({ type: ADMIN_ORDERS.FAILED, payload: e.response.data });
  }
}

export function* updateAdminOrders(action) {
  try {
    yield put({ type: LOADING.VALIDATING });
    yield put({ type: LOADING.SUBMITTING });
    yield call(updateAdminOrder, action.payload);
    const { data: { entity } } = yield call(fetchAdminOrders, action.payload);
    yield put({ type: ADMIN_ORDERS.SUCCESS, payload: entity });
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: 'Order updated successfully',
    });
    yield put({ type: LOADING.VALIDATED });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
  }
}
